module.exports = __webpack_public_path__ + "static/media/29FUNOV7.3a290d13.jpg";